import { render, staticRenderFns } from "./HpgsIDCard.vue?vue&type=template&id=0a962df0&scoped=true&"
import script from "./HpgsIDCard.vue?vue&type=script&lang=js&"
export * from "./HpgsIDCard.vue?vue&type=script&lang=js&"
import style0 from "./HpgsIDCard.vue?vue&type=style&index=0&id=0a962df0&lang=scss&scoped=true&"
import style1 from "./HpgsIDCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a962df0",
  null
  
)

export default component.exports